import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getFileExtension',
})
export class GetFileExtension implements PipeTransform {
  transform(fileName: any): any {
    if (fileName == undefined) {
      return 'doc';
    }
    let type = fileName.replace(/^.*\./, '') != fileName ? fileName.replace(/^.*\./, '') : '';
    if (type == '') {
      return 'doc';
    } else {
      return type.toLowerCase();
    }
  }
}
